module.exports = __webpack_public_path__ + "static/MicroSoft_Azure-4817aa2d2c78a42b5805868b6bc0fe31.png";